import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-627bae02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general-settings" }
const _hoisted_2 = { class: "setting-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Settings", -1))
const _hoisted_4 = { class: "setting-list" }
const _hoisted_5 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RadioInput = _resolveComponent("RadioInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hiddenModal && _ctx.hiddenModal(...args)))
    }, [
      _createVNode(_component_Icon, {
        name: "ic16-close",
        color: "--sui-gray-500"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting, (item) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createVNode(_component_RadioInput, {
              class: _normalizeClass(["setting-item", { active: _ctx.currentTab === item }]),
              item: item,
              name: "settings",
              onClick: ($event: any) => (_ctx.currentTab = item),
              key: item,
              checked: _ctx.currentTab === item
            }, null, 8, ["item", "onClick", "class", "checked"])
          ]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab), { class: "tab" }))
    ])
  ]))
}